module.exports = __webpack_public_path__ + "img/snow-big.a91e68fd.svg";